import { useGetInstrumentBookFundamentals } from '@/gen/marketDataApi'
import { InstrumentDto } from '@/gen/publicApi'

import EffectiveStateCircle from '@/components/effectiveStateCircle'
import Spinner from '@/components/spinner'
import { Table, TableBody, TableCell, TableRow } from '@/components/table'
import TimingEventCircle from '@/components/timingEventCircle'

interface Props {
    clientCode: string
    marketCode: string
    instrument: InstrumentDto
}

export default function InstrumentFundamentals({ clientCode, marketCode, instrument }: Props) {
    const fundamentals = useGetInstrumentBookFundamentals(clientCode, marketCode, instrument.symbol, {
        query: { refetchInterval: 1000 },
    })

    if (fundamentals.isLoading) {
        return <Spinner size="sm" absolute navVisible />
    }

    const currency = (str?: string | null) => {
        return str ? `$${str}` : '--'
    }

    return (
        // <Card hideOverflow className="col-span-2">
        <div className="col-span-2">
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell className="font-semibold">Effective State</TableCell>
                        <TableCell className="text-right">
                            <>
                                {fundamentals.data?.effectiveState && (
                                    <EffectiveStateCircle state={fundamentals.data.effectiveState} className="mr-2" />
                                )}
                                {fundamentals.data?.effectiveState || '--'}
                            </>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="font-semibold">Last Timing Event</TableCell>
                        <TableCell className="text-right">
                            <>
                                {fundamentals.data?.lastTimingEvent && (
                                    <TimingEventCircle state={fundamentals.data.lastTimingEvent} className="mr-2" />
                                )}
                                {fundamentals.data?.lastTimingEvent || '--'}
                            </>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="font-semibold">Day Low</TableCell>
                        <TableCell className="text-right">{currency(fundamentals.data?.dayLow)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="font-semibold">Day High</TableCell>
                        <TableCell className="text-right">{currency(fundamentals.data?.dayHigh)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="font-semibold">Best Bid</TableCell>
                        <TableCell className="text-right">{currency(fundamentals.data?.bestBid)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="font-semibold">Best Ask</TableCell>
                        <TableCell className="text-right">{currency(fundamentals.data?.bestAsk)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    )
}
